<template>
  <li v-if="item.subItem" class="pl-4">
    <button
      class="text-left menu-title text-white flex justify-between items-center w-full py-4"
      @click="toggleCollapse"
    >
      <p>
        <font-awesome-icon v-if="item.icon" class="w-4" :icon="item.icon" />{{
          item.title
        }}
      </p>
      <font-awesome-icon
        class="w-4 transition-all"
        :class="localItem.collapse ? 'rotate-0' : 'rotate-90'"
        :icon="['fas', 'chevron-right']"
      />
    </button>
    <ul
      class="space-y-4 transition -ml-4 pl-8"
      :class="
        localItem.collapse
          ? 'opacity-0 max-h-0 invisible py-0'
          : 'opacity-100 visible max-h-fit'
      "
    >
      <sidebar-menu
        v-for="(item, index) in item.subItem"
        :key="index"
        :item="item"
        :class="{ hidden: !item.condition }"
      />
    </ul>
  </li>
  <li
    v-else
    :class="{ disabled: item.muted }"
    class="text-sm hover:text-yellow-600 py-2"
  >
    <span v-if="item.muted" class="hover:text-gray-500 text-gray-500">
      <font-awesome-icon class="w-4" :icon="item.icon" />{{ item.title }}
    </span>
    <router-link
      :to="{ name: item.routeName }"
      v-else
      class="space-x-4 flex items-center px-8"
      :class="{ 'text-xs': item.smallFont }"
    >
      <font-awesome-icon class="w-4" :icon="item.icon" />
      <p class="inline-block whitespace-pre">
        {{ item.title }}
      </p>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      localItem: { ...this.item },
    };
  },
  methods: {
    toggleCollapse() {
      this.localItem.collapse = !this.localItem.collapse;
    },
  },
};
</script>

<style scoped>
.router-link-active {
  @apply bg-white bg-opacity-10 w-full py-4 flex -my-4;
}
</style>
